/**
 * Textos da mesa única do caso eletrônico (E201.F1, GUS-47, ADR-0144): a pré-análise e a mesa numa
 * tela só. E205 (ADR-0147): o cabeçalho do caso e as abas Exame, Pendências, Documentos, Fotografias
 * e facial e Conclusão.
 */
export const ptBRMesaUnica = {
  sobretitulo: 'Mesa do perito',
  carregando: 'Carregando o caso…',
  ccb: 'CCB {numero}',
  acoes: {
    rotulo: 'Ações do caso',
    conversa: 'Conversa',
    historico: 'Histórico',
    // E205.F1 (ADR-0147 §7): sem caminho de pão; Conferir e assinar, Enviar documentos e o "Mais".
    enviarDocumentos: 'Enviar documentos',
    mais: 'Mais',
    verResultado: 'Ver resultado',
    protocoloEDocumentos: 'Protocolo e documentos',
  },
  // E203.F5.T09: o que o painel do documento abre sai das áreas de baixo; ficam o resumo e o aviso.
  noDocumento: {
    irAoDocumento: 'Resolver no documento',
    abrirAqui: 'Abrir aqui',
    recolher: 'Recolher',
    // E209.F2.T01 (GUS-296 item 5c): registrar a conclusão é facultativo (E180.F2, GUS-254); o resumo
    // não chama de falta o que o perito pode deixar com a conclusão apurada pelo sistema.
    conclusaoPendente: '{n} CCBs sem conclusão registrada (facultativo)',
    umaConclusaoPendente: '1 CCB sem conclusão registrada (facultativo)',
    conclusaoFeita: 'CCBs concluídas',
    revisoesPendentes: '{n} pontos para o perito revisar',
    umaRevisaoPendente: '1 ponto para o perito revisar',
    semRevisaoPendente: 'Nenhum ponto pendente de revisão',
  },
  // E203.F5.T05: a ficha da leitura recolhida na mesa, com o resumo.
  ficha: {
    informacoes: '{n} informações',
    umaInformacao: '1 informação',
    divergencias: '{m} divergências',
    umaDivergencia: '1 divergência',
    abrir: 'Abrir a ficha',
    recolher: 'Recolher',
  },
  // E203.F5.T02: o protocolo e a tabela de documentos, fora da tela por padrão.
  protocoloEDocumentos: {
    fechar: 'Fechar',
  },
  // E205.F1 (ADR-0147 §1): abas reais, uma visível por vez, escolhidas pelo endereço.
  abas: {
    rotulo: 'Partes da mesa',
    exame: 'Exame',
    pendencias: 'Pendências',
    documentos: 'Documentos',
    fotografias: 'Fotografias e facial',
    conclusao: 'Conclusão',
  },
  // E205.F1 (ADR-0147 §7): os dados do caso no cabeçalho, em campos rotulados.
  dadosDoCaso: {
    rotulo: 'Dados do caso',
    instituicao: 'Instituição',
    parte: 'Parte',
    parteComCpf: '{nome} · CPF {cpf}',
    dataDoAto: 'Data do ato',
    versao: 'Versão do exame',
    versaoComTexto: '{rodada} · {texto}',
    pacote: 'Pacote',
    semValor: '—',
    pacoteCompleto: 'Completo · versão {versao}',
    pacotePreparando: 'Preparando',
    pacoteIncompleto: 'Incompleto',
    pacoteComFalha: 'Com falha',
    pacoteLendo: 'Lendo…',
  },
  secao: {
    documentos: 'Documentos',
  },
  // E205.F3 (ADR-0147 §5): as pendências num lugar só, na ordem do servidor.
  pendencias: {
    rotulo: 'O que falta, na ordem',
    contador: '({n})',
    contadorRotulo: '{n} pendências',
    proximo: 'Próximo passo',
    informativa: 'Não segura a emissão',
    resolver: 'Resolver',
    nadaPendente: 'Nada pendente',
    nadaPendenteTexto:
      'O caso não tem pendência. A conferência final e a assinatura seguem pelo cabeçalho.',
    lendo: 'Lendo o que falta…',
    indisponivel: 'Não foi possível ler as pendências agora. Tente de novo.',
    tentarDeNovo: 'Tentar de novo',
    chip: 'Próximo: {passo}',
    chipRotulo: 'Abrir as pendências',
  },
  // E205.F2 (ADR-0147 §3): um botão "Exame" com as três saídas, na barra da aba Exame.
  exame: {
    botao: 'Exame',
    rotulo: 'Saídas do exame',
    previa: 'Ver prévia (PDF)',
  },
  apoio: 'Documento de apoio',
  // E201.F2 (GUS-47): o documento original ao lado do exame.
  documento: {
    abrir: 'Documentos',
    titulo: 'Documento original',
    fechar: 'Fechar o documento original',
    arquivo: 'Arquivo',
    anterior: 'Anterior',
    proxima: 'Próxima',
    pagina: 'Página {n} de {total}',
    paginaSemTotal: 'Página {n}',
    diminuir: 'Diminuir o zoom',
    aumentar: 'Aumentar o zoom',
    zoom: '{zoom}%',
    quadro: 'Documento original: {nome}',
    carregando: 'Abrindo o documento…',
    carregandoLista: 'Lendo os documentos do caso…',
    semDocumentos: 'Este caso ainda não tem documento em PDF ou imagem para abrir aqui.',
    erroDaLista: 'Não foi possível listar os documentos do caso.',
    // E205.F4.T03: o que não abre diz por quê, no lugar do erro de sempre.
    porQue: {
      divergente:
        'Custódia: o arquivo guardado não confere com o recebido. Por segurança, ele não é aberto.',
      nao_encontrado: 'O arquivo não está mais no caso: foi excluído ou não foi encontrado.',
      fora_do_recorte: 'Este arquivo está fora do acervo que a sua conta pode abrir.',
      falha: 'Não foi possível abrir o documento agora. Tente de novo.',
    },
    dica: 'No PDF, o texto se seleciona e copia no próprio documento.',
    // E201.F2.C01 (F-E201.F2-01): o arquivo pedido não é trocado por outro.
    escolha: 'Escolha um arquivo',
    foraDoPainel: 'O arquivo {nome} não abre neste painel. Abra o original para conferir.',
    naoEncontrado: 'O arquivo pedido não está entre os documentos do caso.',
  },
} as const;
